import { render, staticRenderFns } from "./checkdetail.vue?vue&type=template&id=265a2266&scoped=true&"
import script from "./checkdetail.vue?vue&type=script&lang=js&"
export * from "./checkdetail.vue?vue&type=script&lang=js&"
import style0 from "./checkdetail.vue?vue&type=style&index=0&id=265a2266&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265a2266",
  null
  
)

export default component.exports